import axios from 'axios';
import {url} from '../../../utils/urls';

const withCredentials = true;
const headers = { "Content-Type": "application/json" };


export const getProductManagerConfig = ({ siteId }) => axios.get(`${url.ppa.url}/v1/configs/productManager/${siteId}`, { withCredentials })

export const updateProductManagerConfig = ({ siteId, requestData }) => axios.post(`${url.ppa.url}/v1/configs/productManager/${siteId}`, requestData, { headers, withCredentials })

export const getProductCodeUploadStatus = ({ siteId }) => axios.get(`${url.ppa.url}/v2/sites/codeuploadStatus/${siteId}`, { withCredentials })

export const updateControlBarConfig = ({ siteId, requestData }) => axios.post(`${url.ppa.url}/v1/configs/productManager/${siteId}/controlBarConfig`, requestData, { headers, withCredentials })